import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Camera } from 'lucide-react';

const GALLERY_PHOTOS = [
  {
    url: '/media/founder/2_-_Copy.jpg',
    title: 'गंगा आरती',
    category: 'पूजा',
    desc: 'पवित्र गंगा तट पर दीप आरती करते हुए'
  },
  {
    url: '/media/founder/IMG-1647.jpg',
    title: 'न्यूज़ चैनल पर',
    category: 'VIP',
    desc: 'प्रसिद्ध नेता के साथ न्यूज़ स्टूडियो में'
  },
  {
    url: '/media/founder/IMG-3548.JPG',
    title: 'Zee हिंदुस्तान समिट',
    category: 'VIP',
    desc: 'Zee हिंदुस्तान के प्रतिष्ठित कार्यक्रम में'
  },
  {
    url: '/media/founder/20151102_120328_-_Copy__1_.jpg',
    title: 'गुरु आशीर्वाद',
    category: 'आध्यात्मिक',
    desc: 'पूज्य गुरुदेव से आशीर्वाद प्राप्त करते हुए'
  },
  {
    url: '/media/founder/IMG-4602.JPG',
    title: 'संतों के सानिध्य में',
    category: 'आध्यात्मिक',
    desc: 'प्रसिद्ध संतों एवं विद्वानों के साथ'
  },
  {
    url: '/media/founder/IMG-0468.JPG',
    title: 'गौ सेवा',
    category: 'सेवा',
    desc: 'गौ माता की सेवा - जीव दया का संदेश'
  },
  {
    url: '/media/founder/20141012_164128.jpg',
    title: 'गौशाला सेवा',
    category: 'सेवा',
    desc: 'गौशाला में बछड़े के साथ - प्रेम और करुणा'
  },
  {
    url: '/media/founder/IMG_9466-removebg-preview.png',
    title: 'कुंडली विश्लेषण',
    category: 'परामर्श',
    desc: 'कुंडली का गहन अध्ययन एवं विश्लेषण करते हुए'
  },
  {
    url: '/media/founder/IMG_9620-removebg-preview.png',
    title: 'Vivek Mudgal Astrologer',
    category: 'व्यक्तिगत',
    desc: 'वैदिक ज्योतिष, वास्तु एवं कॉस्मिक हीलिंग विशेषज्ञ'
  },
  {
    url: '/media/founder/Untitled_design.jpg',
    title: 'Vivek Mudgal - Professional Portrait',
    category: 'व्यक्तिगत',
    desc: 'अपने कार्यालय में - ज्योतिष एवं वास्तु परामर्श के लिए उपलब्ध'
  },
  {
    url: '/media/founder/Untitled_design__1_.jpg',
    title: 'ज्योतिषाचार्य विवेक मुद्गल',
    category: 'व्यक्तिगत',
    desc: '33+ वर्षों का अनुभव - वैदिक ज्योतिष में विशेषज्ञता'
  },
  {
    url: '/media/founder/20260131_145104.jpg',
    title: 'ज्योतिष परामर्श',
    category: 'परामर्श',
    desc: 'व्यक्तिगत ज्योतिष परामर्श सत्र'
  },
  {
    url: '/media/founder/20260131_144834.jpg',
    title: 'पंडित जी',
    category: 'व्यक्तिगत',
    desc: '33+ वर्षों का दिव्य अनुभव'
  },
  {
    url: '/media/founder/IMG_7119.jpg',
    title: 'ABP न्यूज़ पर',
    category: 'मीडिया',
    desc: 'ABP न्यूज़ चैनल पर ज्योतिष विशेषज्ञ के रूप में'
  },
  {
    url: '/media/founder/National_Channel_Zee_News_पर_BJP_spokesperson_Prem_Shukla_JI_क__स_थ_Vivek_Mudgal__.jpeg',
    title: 'Zee News - BJP प्रवक्ता प्रेम शुक्ला जी के साथ',
    category: 'मीडिया',
    desc: 'Zee News पर "क्या कहता है इंडिया" शो में'
  },
  {
    url: '/media/founder/IMG_7085.jpeg',
    title: 'Zee News डिबेट',
    category: 'मीडिया',
    desc: 'Zee News "क्या कहता है इंडिया" डिबेट शो में पैनलिस्ट'
  },
  {
    url: '/media/founder/News_nation_Channel_पर_Vivek_Mudgal_.jpeg',
    title: 'News Nation चैनल',
    category: 'मीडिया',
    desc: 'News Nation चैनल पर राष्ट्रीय बहस में भागीदारी'
  },
  {
    url: '/media/founder/IMG_7574__1_.jpeg',
    title: 'प्रेस कॉन्फ्रेंस',
    category: 'VIP',
    desc: 'वरिष्ठ नेताओं के साथ प्रेस कॉन्फ्रेंस में'
  },
  {
    url: '/media/founder/20241101_193203.jpg',
    title: 'अहोई माता पूजा',
    category: 'पूजा',
    desc: 'जय अहोई माता - विवेक मुद्गल परिवार द्वारा पूजा अर्चना'
  },
  {
    url: '/media/founder/20241101_185258.jpg',
    title: 'पूजा अनुष्ठान',
    category: 'पूजा',
    desc: 'विवेक मुद्गल जी द्वारा वैदिक पूजा विधि का संचालन'
  },
  {
    url: '/media/founder/20240916_151951.jpg',
    title: 'हवन पूजा',
    category: 'पूजा',
    desc: 'अग्नि हवन - वैदिक अनुष्ठान एवं मंत्रोच्चारण'
  },
  {
    url: '/media/founder/20240915_132342.jpg',
    title: 'शिवलिंग पूजा',
    category: 'पूजा',
    desc: 'भगवान शिव की पूजा - शिवलिंग अभिषेक एवं अर्चना'
  },
  {
    url: '/media/founder/20240916_152052.jpg',
    title: 'हवन अनुष्ठान',
    category: 'पूजा',
    desc: 'वैदिक हवन - अग्नि पूजा एवं आहुति'
  }
];

const CATEGORIES = ['सभी', 'मीडिया', 'पूजा', 'VIP', 'आध्यात्मिक', 'सेवा', 'परामर्श', 'व्यक्तिगत'];

export default function PhotoGallery() {
  const [activeCategory, setActiveCategory] = useState('सभी');
  const [lightbox, setLightbox] = useState(null);

  const filtered = activeCategory === 'सभी'
    ? GALLERY_PHOTOS
    : GALLERY_PHOTOS.filter(p => p.category === activeCategory);

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const prevPhoto = () => setLightbox((prev) => (prev > 0 ? prev - 1 : filtered.length - 1));
  const nextPhoto = () => setLightbox((prev) => (prev < filtered.length - 1 ? prev + 1 : 0));

  return (
    <section id="gallery" className="section-padding relative overflow-hidden" data-testid="photo-gallery-section">
      <div className="absolute inset-0 cosmic-bg-alt" />
      <div className="absolute top-1/3 left-0 w-72 h-72 bg-gold/5 rounded-full blur-[100px]" />
      <div className="absolute bottom-1/4 right-0 w-64 h-64 bg-purple/8 rounded-full blur-[100px]" />

      <div className="container-custom relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-xs tracking-[0.3em] uppercase text-gold font-semibold font-body mb-4">
            Photo Gallery | फोटो गैलरी
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium text-text-main mb-4 tracking-tight">
            दिव्य <span className="text-gold-gradient">झलकियां</span>
          </h2>
          <p className="text-text-muted text-sm">पूजा, परामर्श और आध्यात्मिक यात्रा की कुछ यादगार तस्वीरें</p>
          <div className="divine-divider mt-6 max-w-xs mx-auto" />
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${
                activeCategory === cat
                  ? 'bg-gradient-to-r from-gold to-gold-dark text-background'
                  : 'bg-white/5 text-text-muted border border-white/10 hover:border-gold/30 hover:text-gold'
              }`}
              data-testid={`gallery-filter-${cat}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {filtered.map((photo, i) => (
            <div
              key={i}
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-square"
              onClick={() => openLightbox(i)}
              data-testid={`gallery-photo-${i}`}
            >
              <img
                src={photo.url}
                alt={photo.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <p className="text-gold text-xs uppercase tracking-wider mb-1">{photo.category}</p>
                <h4 className="text-white font-heading text-lg font-medium">{photo.title}</h4>
                <p className="text-white/70 text-xs mt-1">{photo.desc}</p>
              </div>
              {/* Camera icon */}
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Camera className="w-4 h-4 text-gold" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center"
          onClick={closeLightbox}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors z-10"
            data-testid="lightbox-close"
          >
            <X className="w-5 h-5 text-white" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevPhoto(); }}
            className="absolute left-4 md:left-8 w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors z-10"
          >
            <ChevronLeft className="w-6 h-6 text-white" />
          </button>

          <div className="max-w-4xl max-h-[85vh] px-4" onClick={(e) => e.stopPropagation()}>
            <img
              src={filtered[lightbox].url}
              alt={filtered[lightbox].title}
              className="max-w-full max-h-[75vh] object-contain mx-auto rounded-lg"
            />
            <div className="text-center mt-4">
              <p className="text-gold text-xs uppercase tracking-wider">{filtered[lightbox].category}</p>
              <h3 className="text-white font-heading text-xl mt-1">{filtered[lightbox].title}</h3>
              <p className="text-white/60 text-sm mt-1">{filtered[lightbox].desc}</p>
            </div>
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); nextPhoto(); }}
            className="absolute right-4 md:right-8 w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors z-10"
          >
            <ChevronRight className="w-6 h-6 text-white" />
          </button>
        </div>
      )}
    </section>
  );
}
